<template>
    <table class="table table-striped">
        <tbody>
        <tr v-for="inspection_unmarked in inspection_externals"
            v-if="inspection_unmarked.inspection_type == 'UNMARKED' && inspection_unmarked.section_id == section_id">
            <td>{{ inspection_unmarked.element.name }}</td>
            <td v-if="inspection_unmarked.damages && inspection_unmarked.damages.length > 0">
                <div class="red" v-for="damage in inspection_unmarked.damages">
                    {{ damage.name }}
                </div>
            </td>
            <td v-else>
                <div class="green">В порядке</div>
            </td>
            <td>
                <button v-if="inspection_unmarked.element.type == 'PANEL_ROOF'" class="btn btn-sm btn-edit" v-on:click="inspection_unmarked.photo.display = !inspection_unmarked.photo.display">Смотреть фото</button>
                <div v-if="inspection_unmarked.photo.display" class="inspection-photo">
                    <a :href="inspection_unmarked.photo.url" target="_blank">
                        <img :src="inspection_unmarked.photo.url">
                    </a>
                </div>
            </td>
        </tr>
        </tbody>
    </table>
</template>
<script>
    export default {
        name: 'InspectionExternalUnmarked',
        props: [
            'inspection_externals',
            'section_id'
        ],
        methods: {}
    }
</script>


// WEBPACK FOOTER //
// InspectionExternalUnmarked.vue?98e5f106